<template>
  <ul
    class="flex gap-2"
    :aria-label="$t('messages_nl.includes.social.link.preTitle')"
  >
    <li
      v-for="(platform, key) in platforms"
      class="hover:scale-125 transition-all ease-in-out"
    >
      <a
        :href="createUrl(key)"
        :title="platform.name"
        :class="`flex items-center justify-center sharing__button sharing__button--${key} ${platform.color} ${sizes[size]} rounded-full block text-white text-center`"
        :data-gtm="`share/${key}`"
        target="_blank"
        rel="noopener nofollow"
      >
        <img
          :alt="platform.name"
          class="w-1/2 text-white"
          :src="$asset('img/common/social/' + platform.svg)"
          width="20"
          height="20"
          loading="lazy"
        >
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'adivare-share-widget',
  props: ['size', 'twitterHandle', 'cancellationReview', 'isSingleReview', 'companyName'],
  data() {
    return {
      pageTitle: '',
      extraParams: '',
      sizes: {
        'xs': 'h-7 w-7',
        'sm': 'h-9 w-9',
        'md': 'h-10 w-10',
        'lg': 'h-16 w-16'
      },
      platforms: {
        'facebook': {
          'name': 'Facebook',
          'base_url': 'https://www.facebook.com/sharer/sharer.php?',
          'color': 'bg-facebook',
          'svg': 'fb.svg'
        },
        'twitter': {
          'name': 'Twitter',
          'base_url': 'https://twitter.com/intent/tweet?',
          'color': 'bg-twitter',
          'svg': 'x.svg'
        },
        'linkedin': {
          'name': 'LinkedIn',
          'base_url': 'https://www.linkedin.com/shareArticle?',
          'color': 'bg-linkedin',
          'svg': 'li.svg'
        },
        'whatsapp': {
          'name': 'Whatsapp',
          'base_url': 'https://wa.me/?',
          'color': 'bg-whatsapp',
          'svg': 'wa.svg'
        }
      },
      url: window.location.protocol + '//' + window.location.host + window.location.pathname,
    }
  },
  created: function() {
    this.pageTitle = this.getPageTitle();
    this.extraParams = this.getExtraParams();
  },
  methods: {
    getPageTitle() {
      let pageTitle = '';
      if (typeof this.cancellationReview !== 'undefined' && this.isSingleReview !== true) {
        pageTitle = this.$t('messages_nl.cancellation.cancellationReview.meta.title', { name: this.cancellationReview.name, companyName: this.companyName });
      } else {
        pageTitle = document.title;
      }

      return pageTitle;
    },
    getExtraParams() {
      let shareUrl = '';
      if (typeof this.cancellationReview !== 'undefined' && this.isSingleReview !== true) {
        shareUrl = this.url.substring(0, this.url.lastIndexOf('/')+1) + 'review/' + this.cancellationReview.id + '?'
      } else {
        shareUrl = this.url + '?'
      }
      return {
        'facebook': {
          'u': shareUrl + this.urlParams('facebook'),
        },
        'twitter': this.getTwitterParams(shareUrl),
        'linkedin': {
          'url': shareUrl + this.urlParams('linkedin'),
          'text': this.pageTitle,
        },
        'whatsapp': {
          'text': this.pageTitle + '\n\n' + shareUrl + this.urlParams('whatsapp'),
        },
      }
    },
    urlParams(platform) {
      const params = {
        'utm_source': platform,
        'utm_medium': 'social',
        'utm_campaign': 'socialsharing_web'
      }
      let parameterString = '';
      Object.entries(params).forEach(([key, value], index, array) => {
        parameterString += `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
        if (array.length - 1 !== index ) {
          parameterString += '&';
        }
      })
      return parameterString;
    },
    getTwitterParams(shareUrl) {
      const twitterDefault = {
        'url': shareUrl + this.urlParams('twitter'),
        'text': this.pageTitle,
        'lang': this.$i18n.locale,
      };

      if (this.twitterHandle) {
        const twitterHandleParam = {
          'via': this.twitterHandle
        };
        return { ...twitterDefault, ...twitterHandleParam }
      } else {
        return twitterDefault
      }
    },
    createUrl(platform) {
      const params = this.extraParams[platform]
      let parameterString = '';
      Object.entries(params).forEach(([key, value], index, array) => {
        parameterString += `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
        if (array.length - 1 !== index ) {
          parameterString += '&';
        }
      });
      return this.platforms[platform].base_url + parameterString;
    },
  }
}
</script>
